export const resolveMapHref = ({ mapUrl, latitude, longitude, address } = {}) => {
  const directMapUrl = String(mapUrl || '').trim();
  if (directMapUrl) return directMapUrl;
  const lat = Number.parseFloat(latitude);
  const lng = Number.parseFloat(longitude);
  if (Number.isFinite(lat) && Number.isFinite(lng)) {
    return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
  }
  const addressValue = address && typeof address === 'object'
    ? address.address || address.description || address.street || address.name || ''
    : address;
  const query = String(addressValue || '').trim();
  return query ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}` : '';
};

export const normalizeAppointmentTypes = (value) => {
  if (!Array.isArray(value)) return [];
  const allowed = new Set(['regular', 'waiting', 'online', 'home_visit']);
  return [...new Set(value.map((item) => item === 'address' ? 'home_visit' : item))]
    .filter((item) => allowed.has(item));
};
